import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { HiArrowUp } from 'react-icons/hi';
import { FaInstagram, FaWhatsapp } from 'react-icons/fa';

const WHATSAPP_MESSAGE = encodeURIComponent('Olá Ecosistemas, gostaria de saber mais dos seus produtos.');
const WHATSAPP_URL = `https://wa.me/5567984485377?text=${WHATSAPP_MESSAGE}`;

function Footer() {
  const [showBackToTop, setShowBackToTop] = useState(false);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 320);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const socialLinks = [
    { icon: FaInstagram, href: 'https://www.instagram.com/ecosistemas2026/', label: 'Instagram', color: '#E4405F' },
    { icon: FaWhatsapp, href: WHATSAPP_URL, label: 'WhatsApp', color: '#25D366' },
  ];

  const footerLinks = [
    { label: 'Início', href: '/#hero-area' },
    { label: 'Produtos', href: '/#products' },
    { label: 'Serviços', href: '/#services' },
    { label: 'Processo', href: '/#feature' },
    { label: 'Contato', href: '/#contact' },
  ];

  return (
    <footer>
      <div
        style={{
          height: '1px',
          background: 'linear-gradient(90deg, transparent, rgba(59,158,212,0.40), rgba(107,189,223,0.40), transparent)',
        }}
      />

      <div
        style={{
          background: 'rgba(235,246,252,0.92)',
          backdropFilter: 'blur(20px)',
          padding: '56px 0 34px',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: '-30%',
            right: '-6%',
            width: '340px',
            height: '340px',
            background: 'radial-gradient(circle, rgba(107,189,223,0.15) 0%, transparent 70%)',
            borderRadius: '50%',
            pointerEvents: 'none',
          }}
        />

        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="row" style={{ rowGap: '28px' }}>
            <div className="col-lg-5 col-md-12">
              <h3
                style={{
                  fontSize: '1.85rem',
                  fontWeight: 800,
                  marginBottom: '14px',
                  color: '#1A2D3A',
                }}
              >
                Ecosistemas
              </h3>
              <p style={{ color: '#5A7A8E', lineHeight: 1.8, maxWidth: '420px', marginBottom: '20px' }}>
                Sistemas com leitura operacional, implantação próxima e experiência construída para o trabalho do dia a dia.
              </p>

              <div style={{ display: 'flex', gap: '12px' }}>
                {socialLinks.map((social) => {
                  const Icon = social.icon;

                  return (
                    <motion.a
                      key={social.label}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.label}
                      whileHover={{ y: -3, scale: 1.03 }}
                      whileTap={{ scale: 0.98 }}
                      style={{
                        width: '46px',
                        height: '46px',
                        background: 'rgba(255,255,255,0.82)',
                        border: '1px solid rgba(59,158,212,0.18)',
                        borderRadius: '14px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: social.color,
                        boxShadow: `0 8px 18px ${social.color}12`,
                      }}
                    >
                      <Icon size={18} />
                    </motion.a>
                  );
                })}
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <h4 style={{ fontSize: '0.86rem', fontWeight: 700, color: '#6A8899', marginBottom: '18px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                Navegação
              </h4>
              <ul style={{ display: 'grid', gap: '12px' }}>
                {footerLinks.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      style={{
                        color: '#4A6680',
                        fontWeight: 600,
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px',
                      }}
                    >
                      <span
                        style={{
                          width: '7px',
                          height: '7px',
                          borderRadius: '50%',
                          background: 'linear-gradient(135deg, #3B9ED4, #6BBDDF)',
                        }}
                      />
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-lg-4 col-md-6">
              <h4 style={{ fontSize: '0.86rem', fontWeight: 700, color: '#6A8899', marginBottom: '18px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                Contato
              </h4>
              <div style={{ color: '#5A7A8E', lineHeight: 1.9 }}>
                <p>R. Ten. Bernardes n° 790 - Centro</p>
                <p>Jardim - MS, 79240-000</p>
                <p>
                  <a href="tel:+5567984485377" style={{ color: '#4A6680', fontWeight: 600 }}>
                    (67) 98448-5377
                  </a>
                </p>
                <p>
                  <a href="mailto:ecosistemas.computacao@gmail.com" style={{ color: '#4A6680', fontWeight: 600 }}>
                    ecosistemas.computacao@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ background: 'rgba(214,238,248,0.95)', padding: '18px 0', borderTop: '1px solid rgba(59,158,212,0.10)' }}>
        <div className="container" style={{ textAlign: 'center', color: '#6A8899', fontSize: '0.92rem' }}>
          © {currentYear} Ecosistemas Computação. Sistemas pensados para operação real.
        </div>
      </div>

      <AnimatePresence>
        {showBackToTop && (
          <motion.button
            initial={{ opacity: 0, y: 20, scale: 0.8 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.8 }}
            whileHover={{ scale: 1.05, y: -3 }}
            whileTap={{ scale: 0.96 }}
            onClick={scrollToTop}
            style={{
              position: 'fixed',
              bottom: '24px',
              right: '24px',
              width: '54px',
              height: '54px',
              background: 'linear-gradient(135deg, #3B9ED4 0%, #6BBDDF 100%)',
              borderRadius: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              boxShadow: '0 10px 24px rgba(59,158,212,0.28)',
              zIndex: 9999,
            }}
            aria-label="Voltar ao topo"
          >
            <HiArrowUp size={24} />
          </motion.button>
        )}
      </AnimatePresence>
    </footer>
  );
}

export default Footer;
